<rpe-page-template title="{{ 'rpe.vista-tecnico-responsable.title' | translate }}" route="main/landing">
<ng-container slot="content">
  <div class="container">
    <div class="row">
      <rpe-entity-tecnico-responsable-form-container></rpe-entity-tecnico-responsable-form-container>
    </div>
  </div>
</ng-container>
</rpe-page-template>
